import { useContext, useEffect } from "react";
import { sidebarContext } from "../contexts/SidebarProvider";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { open, setOpen } = useContext(sidebarContext);
  const location = useLocation();

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-toggled", "close");
    setOpen(false);
  }, [location, setOpen]);
  return (
    <>
      <div className="scrollToTop">
        <span className="arrow">
          <i className="ti ti-arrow-narrow-up fs-20"></i>
        </span>
      </div>
      <div
        id="responsive-overlay"
        className={open === true ? "active" : ""}
      ></div>
    </>
  );
};

export default ScrollToTop;
